import { colors } from '../../colors';
var input = {
  textColor: colors.smoke
};
export default input;